module.exports = __webpack_public_path__ + "static/media/26UNRWA7.7ab91582.jpg";